import { QuickActionsConstants } from '../store/quickActions.constants'
import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { getQuickActionsSelector } from '../selectors/quickActions.selector'
import { getUserIdSelector } from '../../user/selectors'
import {
  setAssessedBy,
  setAttempts,
  setDateTime,
  setSuccessfulAttempt,
} from '../../procedures/extrication/store/extrication.actions'
import { setAddExtricationToTimeline } from '../store/quickActions.actions'
import { getVitalOptionsSelector } from '../../options/selectors'
import { IVitalOptionsState } from '../../options/store/options.types'

export function* setExtricationQuickAction() {
  const userId = yield select(getUserIdSelector)
  const quickActionsObject = yield select(getQuickActionsSelector)
  const { selectedQuickActionButton } = quickActionsObject
  const { props } = selectedQuickActionButton
  const { savedTimeString, currentDate } = props
  const vitalsOptionsState: IVitalOptionsState = yield select(getVitalOptionsSelector)
  const { assessedByOptions } = vitalsOptionsState
  const assessedByOption = assessedByOptions.find((option) => option.id === +userId)

  yield put(setDateTime(savedTimeString, currentDate))
  yield put(setAssessedBy(assessedByOption ? assessedByOption : null))
  yield put(setSuccessfulAttempt(true))
  yield put(setAttempts('1'))
  yield put(setAddExtricationToTimeline(true))
}

export function* setExtricationQuickActionSaga() {
  yield takeLatest([QuickActionsConstants.SET_IS_EXTRICATION_BUTTON_TYPE], setExtricationQuickAction)
}
